import { OnInit, Injectable } from '@angular/core';
import { MatTableDataSource} from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { BackendService } from '../../services/backend.service';
import { IWellRequestTable } from '../../model/well-request-table.model';
import { RoutingService } from '../../services/routing.service';

@Injectable()
export abstract class WellRequestTableComponent implements OnInit {
  dataSource = new MatTableDataSource<IWellRequestTable>();

  protected paginator!: MatPaginator;
  protected sort!: MatSort;

  constructor(protected backendService: BackendService, private routingService: RoutingService) {
  }

  ngOnInit(): void {
    this.loadWells();
    this.activeRouteTab();
  }

  protected intiPaginator() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getRecord(row: IWellRequestTable) {

    this.routingService.forwardRedirect(row.id.toString(), row.currentStatusId)
  }

  activeRouteTab() { this.routingService.setRoute(this.routingService.router.url) }
  
  applyFilter(event: KeyboardEvent) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (event.key === 'Enter') {
      this.dataSource.filter = filterValue;

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }

      return;
    }

    if (!filterValue && this.dataSource.filter) {
      this.dataSource.filter = '';

      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  loadWells(): void {
    this.backendService.getWellRequestTable().subscribe(data => {
      this.dataSource.data = data;
    })
  }

  getRigSource(row: IWellRequestTable) {
    if (!!(row.manualRigType) || !!(row.manualRigOwner))
      return "Enverus, LOGIX™"
    return row.rigSource
  }
}
